import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

/**
 * Admin gate. The SQL `is_admin()` function (migration 0014) is the single
 * source of truth — the RLS policies call it server-side, and this hook asks
 * the same function, so the allowlist never ships in (or drifts from) the
 * client bundle. RLS remains the actual authority; this only gates UI.
 */
export function useIsAdmin(): { isAdmin: boolean; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ['is_admin'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('is_admin');
      if (error) return false;
      return data === true;
    },
    staleTime: 10 * 60 * 1000,
  });
  return { isAdmin: data === true, isLoading };
}
